import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { LoginComponent } from './pages/login/login.component';
import { MychatroomComponent } from './pages/mychatroom/mychatroom.component';
import { FormsModule, ReactiveFormsModule} from '@angular/forms';
import { HttpModule } from '@angular/http';
import { RoutingModule } from './routing.module';
import { HttpClientModule } from '@angular/common/http';
import { DynamicMessageComponent } from './components/dynamicMessage/dynamicMessage.component';
import { CommonModule } from '@angular/common';
import { HttpService } from './services/httpService';
import { httpInterceptorProviders } from './interceptors';
import { AuthService } from './services/auth.service';
import { ApiService } from './services/api.service';
import { CacheService } from './services/cache-service';
import { LocalStorageService } from './services/local-storage.service';
import { RequestCache } from './services/request-cache';
import { RequestCacheService } from './services/request-cache.service';
import { LearnComponent } from './pages/learn/learn.component';
import { RegisterComponent } from './pages/register/register.component';
import { AlertComponent } from './components/alert/alert.component';
import { AlertService } from './services/alert.service';
import { UserService } from './services/user.service';
import { VerifyCodeService } from './components/verifycanvas/verifyCodeService';
import { AuthGuard } from './guard/auth.guard';
import { RegisterConfirmComponent } from './pages/register-confirm/register-confirm.component';
import { WebSocketService } from './services/webSocketService';

@NgModule({
  declarations: [
    AppComponent,
    AlertComponent,
    LoginComponent,
    MychatroomComponent,
    RegisterComponent,
    RegisterConfirmComponent,
    LearnComponent,
    DynamicMessageComponent
  ],
  entryComponents: [DynamicMessageComponent],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    RoutingModule,
    HttpModule,
    HttpClientModule,
    CommonModule
  ],
  providers: [HttpService, AuthService,ApiService,CacheService, WebSocketService, AuthGuard, UserService, AlertService, VerifyCodeService,
    {
      provide: RequestCache,
      useClass: RequestCacheService,
    },
    LocalStorageService,
    httpInterceptorProviders],
  bootstrap: [AppComponent]
})
export class AppModule { }
